<template>
  <div class="ScrollParallax">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    mounted()
    {
      if(!this.$tools.isMobile())
        this.$scroll.set(this.$el, { y: 0 }, { y: 70 }, { y: -70 })
    }
  }
</script>

<style lang="stylus" scoped>
.ScrollParallax

  will-change transform
  -webkit-will-change transform
</style>